import { getAccountDetails } from "@api-routes/bff";
import { useFetch } from "@common/hook/useFetch";
import { useEffect, useState } from "react";
import { IAccountDetailsPage } from "./interface/IAccountDetailsPage";
import { useGetAccountDetails } from "@features/AccountDetails/hook/useGetAccountDetails";

export const useAccountDetailsPage = () => {
    const [accountDetails, setAccountDetails] = useState<IAccountDetailsPage>();
    const [accountDetailsState, { get }] = useFetch();
    const { accountDetails: account, accountDetailsState: accountState } = useGetAccountDetails();

    useEffect(() => {
        get<IAccountDetailsPage>(getAccountDetails()).then((accountDetailsResponse) => {
            if (accountDetailsResponse) {
                setAccountDetails(accountDetailsResponse);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        account,
        accountDetails,
        hasMobileSubscriptions: !accountDetailsState.isLoading && (accountDetails?.mobileSubscriptions.length ?? 0) > 0,
        isLoading: accountDetailsState.isLoading && accountState.isLoading,
    };
};
